export default __webpack_public_path__ + "5c6e8da4c004d93339e0027d55f71e1b.png";